import React from 'react';
import PropTypes from 'prop-types';
import ExternalRedirect from '../components/redirect/ExternalRedirect';
import NotFoundPage from './Error404';
import config from '../../config';
import {
    isNewAppShapePath,
    sameOriginRedirectUrl,
    seoLocationRedirectPath,
} from '../utils/seoLocationRoutes';

// FEWD-336: the bare /{location} landing pages are discontinued in favor of
// the new app's /locations pages. This must stay a CLIENT redirect — these
// catch-all routes only match when no other SPA route did, a condition the
// Express layer cannot reproduce. The suffixed SEO shapes get true 301s in
// src/server/index.js; this component is their client-navigation fallback.
const SeoLocationRedirect = ({ location }) => {
    // Reaching this component with a path already in the new app's shape means
    // Front Door has no rule for it, so redirecting would target this very URL
    // and spin forever. Render not-found instead — the loop was worse than a 404.
    if (isNewAppShapePath(location.pathname)) {
        return <NotFoundPage />;
    }

    // The target is derived from the URL, so it is attacker-influenced: refuse
    // anything that resolves off nextAppHost rather than handing the visitor to
    // another origin.
    const target = sameOriginRedirectUrl(
        seoLocationRedirectPath(location.pathname),
        config.nextAppHost,
    );

    if (!target) {
        return <NotFoundPage />;
    }

    return <ExternalRedirect to={target} />;
};

SeoLocationRedirect.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
};

export default SeoLocationRedirect;
